import { useQuery } from '@apollo/client';
import { GET_REPLIES_QUERY } from '../graphql/resolvers/postQueries/getReplies.gql';

export function useReplies(parentPostId?: string, limit = 20) {
  const { data, loading, error, fetchMore, networkStatus, refetch } = useQuery(
    GET_REPLIES_QUERY,
    {
      variables: { parentPostId: parentPostId ?? '', limit, nextToken: null },
      skip: !parentPostId,
      notifyOnNetworkStatusChange: true,
      fetchPolicy: 'network-only',
    },
  );

  const connection = data?.getReplies;
  const items = connection?.items ?? [];
  const nextToken = connection?.nextToken ?? null;

  const loadMore = async () => {
    if (!parentPostId || !nextToken) return;
    await fetchMore({
      variables: { parentPostId, limit, nextToken },
      updateQuery: (prev, { fetchMoreResult }) => {
        if (!fetchMoreResult?.getReplies) return prev;

        return {
          ...prev,
          getReplies: {
            // Spread prev to preserve the connection __typename (added at
            // runtime by Apollo's addTypename; omitted from the codegen type).
            ...prev.getReplies,
            items: [
              ...(prev.getReplies?.items ?? []),
              ...(fetchMoreResult.getReplies.items ?? []),
            ],
            nextToken: fetchMoreResult.getReplies.nextToken,
          },
        };
      },
    });
  };

  return { items, nextToken, loading, error, loadMore, refetch, networkStatus };
}
